import { Commit, Action, ActionTree, ActionContext } from 'vuex'
import JobService from '@/features/job/job.service'

import {
  FETCH_PRE_URL,
  FETCH_JOB,
  FETCH_URL_LOCALLY,
  CREATE_JOB_ACTION,
  CLEAR_UPLOAD,
  SAVE_PARSING_OPTIONS
} from '@/system/store/action-types'
import {
  SET_PRESIGNED_URL,
  CLEAR_UPLOAD_DATA,
  SET_PARSING_OPTIONS
} from '@/system/store/mutation-types'
import {
  IParsingOptions,
  IUploadStore
} from '@/features/upload/store'

const jobService = new JobService()

const fetchPreSignedUrl: Action<IUploadStore, any> = (
  context: ActionContext<IUploadStore, any>,
  options: any
): any => {
  const { signedUrlParams, action, ...job } = options
  const { url, fields } = signedUrlParams

  return Promise.all([
    context.dispatch(FETCH_JOB, job),
    context.dispatch(FETCH_URL_LOCALLY, { url, fields })
  ])
}

const saveParsingOptions: Action<IUploadStore, any> = (
  context: ActionContext<IUploadStore, any>,
  parsingOptions: IParsingOptions
): void => context.commit(SET_PARSING_OPTIONS, parsingOptions)

const fetchUrlLocally: Action<IUploadStore, any> = (
  context: ActionContext<IUploadStore, any>,
  params: IUploadStore
): void => context.commit(SET_PRESIGNED_URL, params)

const createJobAction: Action<IUploadStore, any> = (
  context: ActionContext<IUploadStore, any>,
  options: any
) => {
  return jobService.createJob({
    ...options
  })
}

const clearUpload: Action<IUploadStore, any> = (
  context: { commit: Commit }
) => context.commit(CLEAR_UPLOAD_DATA)

const actions: ActionTree<IUploadStore, any> = {
  [FETCH_PRE_URL]: fetchPreSignedUrl,
  [FETCH_URL_LOCALLY]: fetchUrlLocally,
  [CREATE_JOB_ACTION]: createJobAction,
  [CLEAR_UPLOAD]: clearUpload,
  [SAVE_PARSING_OPTIONS]: saveParsingOptions
}

export default actions
